import React, {Component} from 'react';



class SearchPanelCycleItem extends Component {

    componentDidMount = () => {      

    }
  

    toggleYearCycle = () => {        
        let o = this.props.cycle;
        o.selected = true;
        this.props.toggleYearCycle(o);                
    }



    render() {     

        return (
            <React.Fragment>                
                <div onClick={this.toggleYearCycle}
                    className={this.props.cycle.selected
                    ? 'calendarMonthsTitle cntered-flex calendarSectionSelected' 
                    : 'calendarMonthsTitle cntered-flex' }>
                    {this.props.cycle.name}
                </div>
            </React.Fragment>            
        )
    }
}





  export default SearchPanelCycleItem
  